import { render } from "./TelephoneManagement.vue?vue&type=template&id=0635ee86&scoped=true"
import script from "./TelephoneManagement.vue?vue&type=script&lang=js"
export * from "./TelephoneManagement.vue?vue&type=script&lang=js"

import "./TelephoneManagement.vue?vue&type=style&index=0&id=0635ee86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0635ee86"]])

export default __exports__